import { HttpClient } from "@wix/http-client";
var httpClient;
export var getHttpClient = function () {
    if (httpClient) {
        return httpClient;
    }
    httpClient = new HttpClient();
    return httpClient;
};
//# sourceMappingURL=utils.js.map